import setCookieBanner from './set-cookie-banner';

export default {
  setCookieBanner,
};
